(function($) {
    "use strict";
    $(function() {
		/** =============================================
		 *  FRONT PAGE DIGIT COUNTING ANIMATION
		 *  ============================================= */

		//digit animation on front page
		if ($(".number-wrapper").length > 0) {
			$(window).scroll(function () {
				var offset = 0;
				var pageTop = $(window).scrollTop();
				var pageBottom = pageTop + $(window).height();
				var elementTop = $(".number-wrapper").offset().top + offset;

				//if the element is in the user's viewport
				if (pageBottom > elementTop) {
					//$(window).off("scroll", startCounter); //to prevent the animation going off if the user continues to scroll
					$('.number-to-anim').each(function () {
						var $this = $(this);

						if ($this.hasClass('duringanim')) {
							return;
						}

						//if there is also text not just number
						var number = parseInt($this.text());
						var rest = "";
					
                        

						$this.addClass('duringanim');
						$({Counter: 0}).animate({Counter: number}, { //set the counter first to 0 and go up until the
							duration: 4000,                                   // initial value of the html element
							easing: 'swing',
							step: function () {
								if ($this.hasClass("fraction")) { // if it's not a round number

									//if it's the last step and the number is like 1.0, chop off the .0 from the end
									if ((this.Counter).toFixed(2) == number && number.substr(number.length - 2) == "0") {
										var fixed_text = number.substr(0, number.length - 2) + rest; //counter value + the non-number text
										$this.text(fixed_text);
									}
									else {
										$this.text((this.Counter).toFixed(2) + rest);  //counter value + the non-number text
									}

								}
								else {
									$this.text(Math.ceil(this.Counter) + rest); //counter value + the non-number text
								}
							},

							complete: function () {
								$this.removeClass('duringanim');
								$this.removeClass('number-to-anim');
							}
						});
					});
				}
			});
		}

		
	});
})(jQuery);